import React from 'react';

import PropTypes from 'prop-types';
import { FaUsers, FaBuilding } from 'react-icons/fa';

import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import bgImage from '../../Assets/img/bg.png';
import WithBackground from '../Common/WithBackground';

import './style.css';

const Hero = ({ bg, overlay = 'dark' }) => {
  const { t } = useTranslation();
  const location = useLocation();

  // Get current language from URL or i18n
  const getCurrentLanguage = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const supportedLangs = ['pl', 'rus', 'ua', 'en'];
    return supportedLangs.includes(pathSegments[0]) ? pathSegments[0] : 'pl';
  };

  // Generate language-specific routes
  const getLocalizedRoute = (route) => {
    const currentLang = getCurrentLanguage();

    const routeMap = {
      pl: {
        '/dla-pracownika': '/dla-pracownika',
        '/dla-pracodawcy': '/dla-pracodawcy',
      },
      rus: {
        '/dla-pracownika': '/rus/dla-sotrudnika',
        '/dla-pracodawcy': '/rus/dla-rabotodatelya',
      },
      ua: {
        '/dla-pracownika': '/ua/dlya-pratsivnika',
        '/dla-pracodawcy': '/ua/dlya-robotodavtsya',
      },
      en: {
        '/dla-pracownika': '/en/for-workers',
        '/dla-pracodawcy': '/en/for-employers',
      },
    };

    return routeMap[currentLang][route] || route;
  };

  const heroContent = (
    <section
      className={`hero__section ${bg ? 'hero__section--no-overlay' : ''}`}
      style={
        bg
          ? {}
          : {
              backgroundImage: `url(${bgImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }
      }
    >
      <div className='hero__container'>
        <div className='hero__content'>
          <h1 className='hero__title' data-aos='fade-up' data-aos-delay='100'>
            {t('hero.title')}
          </h1>
          <p className='hero__subtitle' data-aos='fade-up' data-aos-delay='200'>
            {t('hero.subtitle')}
          </p>
        </div>

        <div className='hero__buttons'>
          <Link
            to={getLocalizedRoute('/dla-pracownika')}
            className='hero__button'
            data-aos='fade-right'
            data-aos-delay='300'
          >
            <FaUsers className='hero__button-icon' />
            <div className='hero__button-content'>
              <span className='hero__button-title'>{t('hero.forWorkers')}</span>
            </div>
          </Link>

          <Link
            to={getLocalizedRoute('/dla-pracodawcy')}
            className='hero__button hero__button--secondary'
            data-aos='fade-left'
            data-aos-delay='400'
          >
            <FaBuilding className='hero__button-icon' />
            <div className='hero__button-content'>
              <span className='hero__button-title'>
                {t('hero.forEmployers')}
              </span>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );

  return bg ? (
    <WithBackground bg={bg} overlay={overlay}>
      {heroContent}
    </WithBackground>
  ) : (
    heroContent
  );
};

Hero.propTypes = {
  bg: PropTypes.string,
  overlay: PropTypes.oneOf(['dark', 'light', 'golden', 'none']),
};

Hero.defaultProps = {
  bg: null,
  overlay: 'dark',
};

export default Hero;
